import { useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import ProcessSection from './components/ProcessSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Business() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useEffect(() => {
    document.title = '企業向けデジタル制作サービス | チラシ・ネットショップ・アプリ制作 | ぽかぽか堂 よりみち相談室';
    
    const metaTags = [
      { name: 'description', content: 'チラシ制作、ネットショップ立ち上げ、業務改善アプリ制作など、企業様のデジタル化をトータルサポート。松伏・越谷エリアの中小企業様向けデジタル制作サービス。' },
      { name: 'keywords', content: 'チラシ制作,ネットショップ制作,アプリ制作,デジタル化支援,松伏町,越谷,中小企業,業務改善,エクセルフォーム,AI導入' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: `${siteUrl}/business` },
      { property: 'og:title', content: '企業向けデジタル制作サービス | ぽかぽか堂 よりみち相談室' },
      { property: 'og:description', content: 'チラシ制作、ネットショップ立ち上げ、業務改善アプリ制作など、企業様のデジタル化をトータルサポート。' }
    ];
    
    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    });
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/business`);
  }, [siteUrl]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FAF0E6] to-white">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <PricingSection />
      <ProcessSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
